/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

export type Tier = 'Merchant' | 'Enterprise' | 'Premium' | 'Lifetime';

export type FeatureFlag = 
  | 'pos'
  | 'escrow'
  | 'marketplace'
  | 'ai_agent'
  | 'x402_micropayments'
  | 'cross_chain_swaps'
  | 'nft_gating'
  | 'advanced_analytics'
  | 'dedicated_support'
  | 'white_label';

export interface Plan {
  id: string;
  name: Tier;
  price: {
    monthly: number; // USD
    yearly: number; // USD
    lifetime?: number; // USD
  };
  swapFee: number; // Percentage (e.g., 0.025 for 2.5%)
  features: FeatureFlag[];
  limits: {
    transactions: number | 'unlimited';
    teamMembers: number | 'unlimited';
  };
  highlight?: boolean;
  description: string;
}

export const TIER_CONFIGS: Record<Tier, Plan> = {
  Merchant: {
    id: 'plan_merchant',
    name: 'Merchant',
    price: { monthly: 0, yearly: 0 },
    swapFee: 0.025,
    features: ['pos', 'escrow'],
    limits: { transactions: 1000, teamMembers: 1 },
    description: "Essential tools for individuals and small businesses operating on-chain.",
    highlight: false
  },
  Enterprise: {
    id: 'plan_enterprise',
    name: 'Enterprise',
    price: { monthly: 289, yearly: 2774 },
    swapFee: 0.01,
    features: ['pos', 'escrow', 'marketplace', 'advanced_analytics', 'x402_micropayments'],
    limits: { transactions: 'unlimited', teamMembers: 10 },
    description: "Scale your operation with advanced analytics and AI-driven automation.",
    highlight: true
  },
  Premium: {
    id: 'plan_premium',
    name: 'Premium',
    price: { monthly: 499, yearly: 4790 },
    swapFee: 0.005,
    features: ['pos', 'escrow', 'marketplace', 'advanced_analytics', 'x402_micropayments', 'ai_agent', 'cross_chain_swaps', 'dedicated_support'],
    limits: { transactions: 'unlimited', teamMembers: 'unlimited' },
    description: "The complete suite for high-volume traders and autonomous organizations.",
    highlight: false
  },
  Lifetime: {
    id: 'plan_lifetime',
    name: 'Lifetime',
    price: { monthly: 0, yearly: 0, lifetime: 5000 },
    swapFee: 0.0,
    features: ['pos', 'escrow', 'marketplace', 'advanced_analytics', 'x402_micropayments', 'ai_agent', 'cross_chain_swaps', 'dedicated_support', 'nft_gating', 'white_label'],
    limits: { transactions: 'unlimited', teamMembers: 'unlimited' },
    description: "One-time payment for perpetual access to the entire GhostOS ecosystem.",
    highlight: false
  }
};